import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {ClockLastLoginBox} from "./boxes/clock-last-login.box";
import {LastLoginBox} from './boxes/last-login.box';
import {ClockComponent} from "../clock/clock.component";

export const ClockAndLastLoginBoxComponent = observer(class ClockAndLastLoginBoxComponent extends OrbitComponent<{}> {

  render() {
    if (!this.services.configuration.data.ClockAndLastLoginBox.display) {
      return null;
    }

    return (
      <ClockLastLoginBox className="cy-navbar-clock-last-login">
        <ClockComponent format={this.services.time.getTimeFormat()} />
        {this._renderLastLoginComponent()}
      </ClockLastLoginBox>
    );

  }


  private _renderLastLoginComponent(): any {
    let data = this.services.configuration.data;
    if (!data.ClockAndLastLoginBox.lastLoginDisplay) {
      return null;
    }

    return (
      <LastLoginBox className={"cy-last-login-component"}>
        {this.services.regulation.current.components.renderLastLoginComponent()}
      </LastLoginBox>
    );

  }
});

